import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

interface ActionBarContentProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function ActionBarContent({ children, className }: ActionBarContentProps) {
  return <div className={twMerge('mt-5 inline-flex items-center gap-2.5', className)}>{children}</div>;
}

export { ActionBarContent };
